import City from './Component/CityPart/City';

import Home from './Component/Home'
import Foods from './Component/Foods/Foods';
import {Route,Routes}from 'react-router-dom';
import Login from './Component/login/Login';
import Register from './Component/Register/Register';
import Address from './Adresss/Address';
import Addrest from './Component/Addrest/Addrest';
import Cart from "./Component/Cart/Cart"
function App() {
  return (
    <div >
 {/* nnnnnnnnn */}
      <Routes>
    <Route path ="/" element={<Home/>}/>
    <Route path ="/foods" element={<Foods/>}/>
    <Route path ="/login" element={<Login/>}/>
    <Route path ="/register" element={<Register/>}/>
    <Route path ="/address" element={<Address/>}/>
    <Route path ="/addrest" element={<Addrest/>}/>
    <Route path ="/cart" element={<Cart/>}/>
    </Routes>
    
    </div>
  );
}

export default App;
